/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * Login
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Space, Text } from '@cashfree-intl/coherent';

import { EMAIL_LOGIN, ALIAS_LOGIN } from 'utils/constants';

import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';

import Helmet from 'components/Helmet';
import NavigationBar from 'components/NavigationBar';

import { SIGNUP } from '../OnboardingContainer/constants';

import {
  enableLoaderAction,
  updateLoginFormAction,
  authenticateEmailUserAction,
  authenticateAliasAction,
} from '../OnboardingContainer/actions';

import EmailLogin from './components/EmailLogin';
import AliasLogin from './components/AliasLogin';

export function Login(props) {
  const {
    enableLoader,
    formName,
    loginForm,
    emailLogin,
    aliasLogin,
    updateLoginForm,
    switchForm,
    authenticateEmailUser,
    authenticateAlias,
    navigateAsPerUserFlow,
    toggleOTPModal,
    storeErrorLoginResponse,
  } = props;

  const handleNavigationClick = (e, { name }) => {
    Analytics.trackEvent(EVENTS[EMAIL_LOGIN].TAB, { dtabname: name }, 'OB')();
    updateLoginForm(name);
  };

  return (
    <div className="login-container">
      <Helmet
        title="Merchant Login | Cashfree Payments"
        content="Access your Cashfree Payments merchant account securely. Log in to manage payments, transactions, and financial activities effortlessly."
      />
      <Space justifyContent="center" className="mr-btm-20 container-header">
        <div className="header">Login</div>
        <div id="switchForm">
          <Text variant="b12" className="user-select-none">
            <span className="text-light">
              {formName === SIGNUP
                ? 'Have an account?'
                : "Don't have an account?"}
            </span>{' '}
            <span
              className="text-primary font-bold pointer"
              onClick={switchForm}
            >
              {formName === SIGNUP ? 'Log In' : 'Sign Up'}
            </span>
          </Text>
        </div>
      </Space>
      <Space>
        <NavigationBar
          navigationOptions={[EMAIL_LOGIN, ALIAS_LOGIN]}
          activeNavigation={loginForm}
          handleNavigationClick={handleNavigationClick}
        />
      </Space>
      {loginForm === ALIAS_LOGIN ? (
        <AliasLogin
          aliasLogin={aliasLogin}
          navigateAsPerUserFlow={navigateAsPerUserFlow}
          authenticateAlias={authenticateAlias}
          enableLoader={enableLoader}
          onboardingActions={{ toggleOTPModal, storeErrorLoginResponse }}
        />
      ) : (
        <EmailLogin
          emailLogin={emailLogin}
          navigateAsPerUserFlow={navigateAsPerUserFlow}
          authenticateEmailUser={authenticateEmailUser}
          enableLoader={enableLoader}
          onboardingActions={{ toggleOTPModal, storeErrorLoginResponse }}
        />
      )}
    </div>
  );
}

Login.propTypes = {
  enableLoader: PropTypes.func.isRequired,
  formName: PropTypes.string.isRequired,
  loginForm: PropTypes.string.isRequired,
  emailLogin: PropTypes.object.isRequired,
  aliasLogin: PropTypes.object.isRequired,
  updateLoginForm: PropTypes.func.isRequired,
  authenticateEmailUser: PropTypes.func.isRequired,
  authenticateAlias: PropTypes.func.isRequired,
  navigateAsPerUserFlow: PropTypes.func.isRequired,
  switchForm: PropTypes.func.isRequired,
  toggleOTPModal: PropTypes.func.isRequired,
  storeErrorLoginResponse: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    enableLoader: () => dispatch(enableLoaderAction()),
    updateLoginForm: data => dispatch(updateLoginFormAction(data)),
    authenticateEmailUser: data => dispatch(authenticateEmailUserAction(data)),
    authenticateAlias: data => dispatch(authenticateAliasAction(data)),
  };
}

const withConnect = connect(
  null,
  mapDispatchToProps,
);

export default compose(
  withConnect,
  memo,
)(Login);
